import clsx from "clsx";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import AirportRide from "../../components/airportRide";
import CityTrip from "../../components/CityTrip";
import Heading from "../../components/Heading/Heading";
import Paragraph from "../../components/Paragraph/Paragraph";
import RideByHour from "../../components/RideByHour";
import * as PrevPayment from "../../utils/prevPayment";

/**
 * A component that represents the first section in the home page, which most importantly contains the booking forms.
 *
 * @returns {JSX.Element}
 */

const FormsSection = () => {
  const {
    i18n: { language },
  } = useTranslation();
  const servicesList = useSelector(
    (state) => state.cachedRequests.servicesRequest
  );

  const [activeTab, setActiveTab] = useState("");
  const { state } = useLocation();

  useEffect(() => {
    if (!servicesList?.length) {
      return;
    }
    if (PrevPayment.isAirportRide(state)) {
      setActiveTab(servicesList[0].id);
    } else if (PrevPayment.isRideByHours(state)) {
      setActiveTab(servicesList[2].id);
    } else if (PrevPayment.isCityTrip(state)) {
      setActiveTab(servicesList[1].id);
    } else {
      setActiveTab(servicesList[0].id);
    }
  }, [servicesList, state]);

  const handleTabChange = (tabName) => {
    if (
      PrevPayment.isAirportRide(state) ||
      PrevPayment.isRideByHours(state) ||
      PrevPayment.isCityTrip(state)
    ) {
      return;
    }
    setActiveTab(tabName);
  };

  return (
    <>
      <div
        className={clsx(
          {
            "bg-background_white md:bg-airport_ride_bg":
              activeTab === "Airport Trip",
            "bg-background_white md:bg-scheduled_ride_bg":
              activeTab === "City Trip",
            "bg-background_white md:bg-by_hour_bg":
              activeTab === "Book Vehicle In Hours",
          },
          "transition-all duration-300 mx-auto h-auto bg-cover bg-fixed bg-start bg-no-repeat"
        )}
      >
        <div
          className={`inset-0 ${
            language === "ar" ? "bg-gradient-to-l" : "bg-gradient-to-r"
          } from-[#fff] md:from-[#E9B83873] to-transparent py-3 md:py-10 px-2 md:px-10 flex flex-col md:flex-col lg:flex-row justify-start md:justify-between items-center mt-0`}
          style={{ minHeight: "35vh", maxHeight: "750px" }}
        >

          <div className="md:w-[592px]">
            <div className="my-4 hidden md:flex">
              {servicesList?.map((service) => (
                <div key={service.id}>
                  {activeTab === service.id && (
                    <>
                      <div>
                        <Heading
                          title={service.service_name}
                          className="text-2xl md:text-5xl lg:text-5xl text-text_black"
                        />
                      </div>
                      <div className="my-4 w-11/12">
                        <Paragraph
                          title={service.service_desc}
                          className="text-normal md:text-lg  lg:text-lg  text-text_black"
                        />
                      </div>
                    </>
                  )}
                </div>
              ))}
            </div>
          </div>

          <div className="md:w-[592px] mx-3">
            <div
              style={{ minHeight: "120px" }}
              className="bg-background_white py-0 md:py-2 px-0 md:px-4 flex flex-row justify-between items-center rounded transition-all duration-300"
            >
              {servicesList?.map((service) => (
                <button
                  key={service.id}
                  className={`w-2/6 py-1 px-5 md:py-2 md:px-10 flex flex-col items-center cursor-pointer rounded transition-all duration-300 ${
                    activeTab === service.id
                      ? "bg-background_steel_blue text-text_white"
                      : ""
                  }`}
                  onClick={() => handleTabChange(service.id)}
                >
                  <div className="py-1">
                    <img src={service.icon} alt={service.id} />
                  </div>
                  <div className="py-1 text-sm md:text-normal text-center text-text_black font-medium">
                    {service.service_name}
                  </div>
                </button>
              ))}
            </div>

            <div className="mt-0 md:mt-1 bg-background_white p-0 md:p-6 flex flex-row justify-between items-center rounded transition-all duration-300">
              {!activeTab && <div className="min-h-[420px]"></div>}
              {activeTab === "Airport Trip" && (
                <div className="w-full transition-all duration-300">
                  <AirportRide />
                </div>
              )}
              {activeTab === "City Trip" && (
                <div className="w-full transition-all duration-300">
                  <CityTrip />
                </div>
              )}
              {activeTab === "Book Vehicle In Hours" && (
                <div className="w-full transition-all duration-300">
                  <RideByHour />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FormsSection;
